import PropTypes from 'prop-types';

export const props = {
  phoneNumber: PropTypes.string.isRequired,
  whatsappImage: PropTypes.string,
  messageText: PropTypes.string,
  disabled: PropTypes.bool,
};
